export class Cache {
	private data: Record<string, any> = {};
	async getAsync<T>(key: string, factory: () => Promise<T>) {
		return this.data[key] ?? (this.data[key] = await (factory()));
	}
}